module.exports = __webpack_public_path__ + "img/plus-thick.08652f28.svg";